var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.667A9.326 9.326 0 006.666 12C6.666 19 16 29.333 16 29.333S25.333 19 25.333 12A9.327 9.327 0 0016 2.667zm0 12.666a3.334 3.334 0 010-6.666A3.335 3.335 0 0119.333 12 3.335 3.335 0 0116 15.333z",
    fill: "var(--secondary-bittersweet-500)"
  })));
}
export default SvgMarkerIcon;